<template>
  <el-dialog
    :title="$t('addJob.addTask')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="addJobInfo" label-width="120px">
      <el-form-item :label="$t('addJob.taskName')" required>
        <el-input
          v-model="addJobInfo.taskName"
          :placeholder="$t('addJob.enterTaskName')"
        />
      </el-form-item>
      <el-form-item :label="$t('addJob.selectTemplate')" required>
        <el-select
          v-model="addJobInfo.templateId"
          @change="chooseTemplate"
          :placeholder="$t('addJob.selectTemplatePlaceholder')"
          style="width:100%"
        >
          <el-option
            v-for="item in addJobInfo.templates"
            :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addJob.timing')">
        <el-input
          v-model="addJobInfo.taskCron"
          :placeholder="$t('addJob.enterTiming')"
        />
      </el-form-item>
      <el-form-item
        v-for="(item, index) in addJobInfo.templateSpecs"
        :key="index"
        :label="item.specName"
      >
        <el-input
          v-model="item.value"
          :placeholder="item.specDesc"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveJobInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listTaskTemplate, listTaskTemplateSpec, saveTask } from '@/api/dev/jobApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddJob',
  data() {
    return {
      dialogVisible: false,
      addJobInfo: {
        taskName: '',
        templateId: '',
        taskCron: '',
        templates: [],
        templateSpecs: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.queryTemplate()
    },
    handleClose() {
      this.addJobInfo = {
        taskName: '',
        templateId: '',
        taskCron: '',
        templates: [],
        templateSpecs: []
      }
    },
    async queryTemplate() {
      try {
        const res = await listTaskTemplate({
          page: 1,
          row: 30
        })
        this.addJobInfo.templates = res.data
      } catch (error) {
        console.error('获取模板列表失败:', error)
      }
    },
    async chooseTemplate() {
      try {
        const res = await listTaskTemplateSpec({
          templateId: this.addJobInfo.templateId,
          isShow: 'T'
        })
        this.addJobInfo.templateSpecs = res.data.map(item => ({
          ...item,
          value: ''
        }))
      } catch (error) {
        console.error('获取模板规格失败:', error)
      }
    },
    async saveJobInfo() {
      if (!this.validate()) {
        return
      }

      try {
        const params = {
          ...this.addJobInfo,
          shopId: getShopId()
        }
        await saveTask(params)
        this.$message.success(this.$t('addJob.addSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('添加任务失败:', error)
      }
    },
    validate() {
      if (!this.addJobInfo.taskName) {
        this.$message.error(this.$t('addJob.taskNameRequired'))
        return false
      }
      if (!this.addJobInfo.templateId) {
        this.$message.error(this.$t('addJob.templateRequired'))
        return false
      }
      return true
    }
  }
}
</script>